import { api } from "./axiosClient";
import type { OrganisationSettings } from "../types/organizationSettings.types";
import type { BulkOrganisationSettingsPayload } from "../features/organization/organisationSettingsSlice";

export const organisationSettingsApi = {
  searchOrganisationSettings: async (payload: any) => {
    const response = await api.post("/organisationsetting/Search", payload);
    return response.data;
  },

  createOrganisationSettings: async (data: Partial<OrganisationSettings>) => {
    const response = await api.post("/organisationsetting/create", data);
    return response.data;
  },

  updateOrganisationSettings: async (data: Partial<OrganisationSettings>) => {
    const response = await api.post("/organisationsetting/edit", data);
    return response.data;
  },

  removeOrganisationSettings: async (id: string) => {
    return await api.post("/organisationsetting/remove", { id });
  },

  getOrganisationConf: async (organisationId: string) => {
    const response = await api.get("/organisationsetting/getConf", {
      params: { organisationId },
    });
    return response.data;
  },

  bulkCreateOrganisationSettings: async (data: BulkOrganisationSettingsPayload) => {
  const response = await api.post(
    "/organisationsetting/bulkcreate",
    data,
  );
  return response.data;
},
};
